import YouTubePlayer from 'youtube-player';
import Player from '@vimeo/player';

export default class ImageOverVideo {
    constructor() {
        this.init();
    }

    init() {
        this.targetingCookies = window.OptanonActiveGroups && !!(window.OptanonActiveGroups.indexOf('C0004') >= 0);

        if (!this.targetingCookies) {
            $('.js-image-over-video').each((index, element) => {
                const $container = $(element);
                const $iframe = $container.find('iframe');
                $container.find('.consent-message').removeClass('hidden');
                $iframe.remove();
            });
        } else {
            $('.js-image-over-video').on('click', '.video-cover', (e) => {
                const $this = $(e.currentTarget);
                const $cover = $this;
                const $container = $this.closest('.js-image-over-video');
                const $iframe = $container.find('iframe');
                const type = $iframe.attr('data-video-type');
                const vidid = $iframe.attr('data-video-id');

                if (type === "vimeo") {
                    this.player = new Player($iframe[0]);
                    $iframe.fadeIn('fast', () => {
                        $cover.fadeOut('slow');
                    });
                    this.player.play();
                    this.player.on('ended', () => {
                        $cover.fadeIn('fast', () => {
                            $iframe.fadeOut('slow');
                        });
                    });

                } else if (type === "youtube") {
                    this.player = YouTubePlayer($iframe.attr('id'));
                    $iframe.attr(
                        'src',
                        `//www.youtube.com/embed/${vidid}?enablejsapi=1&rel=0`
                    );

                    this.player.on('ready', () => {
                        this.player.playVideo();
                        $iframe.fadeIn('fast', () => {
                            $cover.fadeOut('slow');
                        });
                    });

                    this.player.on('stateChange', (event) => {
                        if (event.data === 0) {
                            $cover.fadeIn('fast', () => {
                                $iframe.fadeOut('slow');
                            });
                        }
                    });
                }

                return false;
            });
        }
    }
}
